import React, { useContext } from 'react';
import { Flex, Image, Text } from '@getgo/chameleon-chakra-ui';
import sanitizeHtml from 'sanitize-html';

import { Button } from '../../../components/Buttons/Button';
import { WFATrackers } from '../../../components/WFATracker/WFATrackers';
import { SessionContext } from '../../../context/SessionContext';
import {
  EngagementData,
  reportToEngagementEngine,
} from '../../../services/EngagementService';

const Callout: React.FC<{ claims: string[] }> = (props) => {
  const maxNumberOfClaimsPerColumn = 3;
  return (
    <Flex id='calloutContainer' wrap='wrap' maxW='517px' my='2rem' mr='2rem'>
      {props.claims.map((claim, index) => {
        return props.claims.length > maxNumberOfClaimsPerColumn ? (
          <Flex
            key={index}
            alignItems='center'
            flexGrow={1}
            flexShrink={0}
            flexBasis='46%'
            textAlign='left'
            mb='1.25rem'
            mr='1.25rem'
            lineHeight='1.4'
          >
            <Image
              id='checkmark'
              alignSelf='baseline'
              pt='0.25rem'
              mr='0.5rem'
              width='1.375rem'
              src={`${process.env.PUBLIC_URL}/static/media/icon-checkmark.svg`}
              alt='checkmark icon'
              aria-hidden='true'
            />
            <Text
              alignSelf='flex-end'
              height='100%'
              mt='0.625rem'
              fontSize='14px'
              width='full'
            >
              {claim}
            </Text>
          </Flex>
        ) : (
          <Flex
            key={index}
            alignItems='center'
            flexGrow={1}
            flexShrink={0}
            flexBasis='100%'
            textAlign='left'
            mb='1.25rem'
            mr='1.25rem'
            lineHeight='1.4'
          >
            <Image
              id='checkmark'
              alignSelf='top'
              mr='0.5rem'
              width='1.375rem'
              src={`${process.env.PUBLIC_URL}/static/media/icon-checkmark.svg`}
              alt='checkmark icon'
              aria-hidden='true'
            />
            <Text height='100%' mt='0.625rem' fontSize='14px'>
              {claim}
            </Text>
          </Flex>
        );
      })}
    </Flex>
  );
};

interface Props {
  engagementData: EngagementData;
}

export const G2MSuccessMarketing: React.FC<Props> = ({ engagementData }) => {
  const { meetingId } = useContext(SessionContext);
  return (
    <Flex
      direction='column'
      borderRadius='0.5rem'
      bgColor='rgba(0, 0, 0, .2)'
      width='fit-content'
      my='1.875rem'
      mx='3.75rem'
      px='1rem'
    >
      <Flex wrap='wrap' justifyContent='center' alignItems='center' pt='2rem'>
        <Flex
          justifyContent='center'
          alignItems='center'
          maxH='300px'
          width='350px'
          mx='2rem'
          mb='2rem'
          overflow='hidden'
        >
          <img
            src={sanitizeHtml(engagementData.engagementMessage.imageURL)}
            alt={engagementData.engagementMessage.imgAlt}
            aria-hidden='true'
          />
        </Flex>
        <Flex direction='column' wrap='wrap' alignItems='center'>
          <Text as='h1'>{engagementData.engagementMessage.headline}</Text>
          <Text>{engagementData.engagementMessage.subHeadline}</Text>
          <Callout claims={engagementData.engagementMessage.claims} />
        </Flex>
      </Flex>

      <Flex
        direction='column'
        alignItems='center'
        justifyContent='center'
        pb='1rem'
        mt='-2rem'
      >
        <Button
          link={engagementData.engagementMessage.ctaURL}
          onClick={() => reportToEngagementEngine(meetingId, engagementData)}
          isExternalLink={true}
          my={5}
        >
          {engagementData.engagementMessage.ctaLinkText}
        </Button>
        <p>{engagementData.engagementMessage.subCTAText}</p>
      </Flex>
      {engagementData.engagementMessage.impressionTrackers && (
        <WFATrackers
          impressionTrackers={
            engagementData.engagementMessage.impressionTrackers
          }
        />
      )}
    </Flex>
  );
};
